<div class="dashboard-content-sec user-filter-space">

    <div class="card hide-overflow">
        <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>
  
        <div class="card-body pb-0">
            <h5>{{contentRec?.Title}}</h5>
        </div>
          
        <div class="card-body" style="width: 650px;">
             <div [innerHTML] = "contentRec?.Body"></div>                   
        </div>
    </div>

</div>